import { ScopeKey } from '@/views/enumerations/types';

export type ScopeType = 'medicalSystemScope' | 'qaEquipmentScope';
export type ScopeProperty = ScopeKey;

export function getTranslationPrefix(scope: ScopeType, property: ScopeProperty) {
  if (scope === 'medicalSystemScope') {
    if (property === 'rtSystemCategory') return 'RtSystemCategoryEnum';

    if (property === 'rtSystemSubCategory') return 'MedicalSystemSubCategoryEnum';

    if (property === 'manufacturer') return 'RtSystemManufacturerEnum';

    if (property === 'model') return 'RtSystemModelEnum';
  }

  if (scope === 'qaEquipmentScope') {
    if (property === 'rtSystemCategory') return 'RtSystemCategoryEnum';

    if (property === 'rtSystemSubCategory') return 'QaEquipmentSubCategoryEnum';
  }
}
